import { atom as jotaiAtom } from 'jotai';

export const newNotificationIndicatorAtom = jotaiAtom<boolean>(false);
